import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import PropertyDeed from "../../searchresults/PropertyDeed";
import AssessmentDetail from "../../searchresults/AssessmentDetail";
import getPersonName from "../../common/Name";
import getBusinessName from "../../common/Business";

class Property extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    const node = this.props.node;
    const internalId = _.get(node, "$.internalID");
    if (node !== undefined) {
      const entities = _.get(node, "entities[0].entity");
      const deedNode = _.get(node, "deed[0]");
      if (entities !== undefined) {
        const propRows = [];
        _.forEach(entities, (entity, index) => {
          const propetyType = _.get(entity, "entityType[0]._");
          propRows.push(
            <Table.Row
              key={`prop_${internalId}_row1_${index}`}
              className="report-sub-section-header"
            >
              <Table.Cell colSpan={4}>
                <center>{propetyType}</center>
              </Table.Cell>
            </Table.Row>
          );
          const addRows = [];
          const nameRows = [];
          const entityAddressNode = _.get(entity, "address");
          if (entityAddressNode) {
            _.forEach(entityAddressNode, (address, addIndex) => {
              addRows.push(
                <Table.Row key={`prop_${internalId}_row2_${index}_${addIndex}`}>
                  <Table.Cell>Address:</Table.Cell>
                  <Table.Cell colSpan={3}>
                    <Address addressNode={address} {...this.props} />
                  </Table.Cell>
                </Table.Row>
              );
            });
          }

          _.forEach(_.get(entity, "names[0].name"), (name, nameIndex) => {
            const companyName = _.get(name, "companyName[0]._", "");
            if (companyName !== "") {
              nameRows.push(
                <Table.Row
                  key={`prop_name_${internalId}_row3_${index}_${nameIndex}`}
                >
                  <Table.Cell>Company Name:</Table.Cell>
                  <Table.Cell colSpan={3}>
                    {getBusinessName(companyName, this.props)}
                  </Table.Cell>
                </Table.Row>
              );
            } else {
              nameRows.push(
                <Table.Row
                  key={`prop_name_${internalId}_row3_${index}_${nameIndex}`}
                >
                  <Table.Cell>Name:</Table.Cell>
                  <Table.Cell colSpan={3}>
                    {getPersonName(
                      _.get(name, "first[0]._", ""),
                      _.get(name, "middle[0]._", ""),
                      _.get(name, "last[0]._", ""),
                      this.props
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            }
          });
          propRows.push(
            <Table.Row key={`Add_Name_${internalId}_row2_${index}`}>
              {addRows.length > 0 && (
                <Table.Cell colSpan={nameRows.length > 0 ? 1 : 2}>
                  <Table className="table-no-border">
                    <Table.Body>{addRows}</Table.Body>
                  </Table>
                </Table.Cell>
              )}
              {nameRows.length > 0 && (
                <Table.Cell colSpan={addRows.length > 0 ? 1 : 2}>
                  <Table className="table-no-border">
                    <Table.Body>{nameRows}</Table.Body>
                  </Table>
                </Table.Cell>
              )}
            </Table.Row>
          );
        });

        rows.push(
          <Table.Row key={`property_row_${internalId}`}>
            <Table.Cell>
              <Table className={"table-no-padding"}>
                <Table.Body>{propRows}</Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
        );
        const assessment = _.get(node, "assessment[0]");
        if (deedNode)
          rows.push(
            <Table.Row key={`property_deed_row_${internalId}`}>
              <Table.Cell>
                <PropertyDeed deedNode={deedNode} />
              </Table.Cell>
            </Table.Row>
          );
        if (assessment)
          rows.push(
            <Table.Row key={`property_assessment_row_${internalId}`}>
              <Table.Cell>
                <AssessmentDetail
                  {...this.props}
                  node={assessment}
                  internalId={internalId}
                />
              </Table.Cell>
            </Table.Row>
          );
      }
    }
    return (
      <Table className="table-no-border table-no-padding">
        <Table.Body>{rows}</Table.Body>
      </Table>
    );
  }
}

export default Property;



// WEBPACK FOOTER //
// ./src/components/reports/Property/Property.js